import React from 'react'
import  FormContact  from '../components/contact/Form'

export  function ContactForm() {

  return (
      <>
        <FormContact />
      </>
      
    )
}

export default ContactForm